import React from 'react'
import './SchulteTable.css'
import { Link } from 'react-router-dom'
import Button from '../../Components/Button'
import Navbar from '../../Components/Navbar'
export default function Win(props) {
    return (
        <>
            <header>
                <Navbar />
            </header>
            <main className="main">
                <div className="game-over-prompt">
                    <h1>Congragulations !</h1>
                    <h1>You Have Won The Game !</h1>
                    <div className="game-over-container">
                        <h2>Your Score is {props.score}</h2>
                        <Button click={props.click} cls="exit-button" number="Play Again"></Button>
                        <Link to="/"><Button cls="exit-button" number="Exit"></Button></Link>
                    </div>
                </div>
            </main>
        </>
    )
}
